'use client'

import { Alert } from '@dxp/components/alert'
import { Button } from '@dxp/components/button'
import { useCmsContext } from '@dxp/components/cms'
import { Input } from '@dxp/components/input'
import { useActionState, useState } from 'react'

import * as actions from '../../../../actions'
import { getErrorText } from '../../../../utils/validation'
import Warning from './warning'

import styles from './signin-form.module.scss'

export const SignInForm = () => {
  const [formState, signInAction] = useActionState(actions.signIn, {})
  const [username, setUsername] = useState('')
  const cms = useCmsContext()
  const showAlert = Boolean(formState.username) && !username

  return (
    <form action={signInAction}>
      {showAlert && (
        <Alert
          data-testid="login-username-error"
          severity="error"
          icon={<Warning />}
          sx={{
            padding: '0 16px 0 8px',
            borderRadius: '4px',
            borderColor: '#9f1d16',
            backgroundColor: '#f8d7da',
            color: '#58151c',
            borderLeftWidth: '5px',
            marginBottom: 1,
          }}
        >
          {getErrorText(formState.username, cms)}
        </Alert>
      )}

      <Input
        name="username"
        InputProps={{ autoComplete: 'username' }}
        fullWidth
        className={styles.username}
        label="Username"
        value={username}
        onChange={e => setUsername(e.target.value)}
      />
      <Button fullWidth className={styles.loginButton} type="submit">
        Log in with username
      </Button>
    </form>
  )
}
